const menu = require("../../../../../components/menu/menu");
const dtHandler = require("../../../../../components/dt/dt-handler");

export function start(detail, htmlDt, htmlFc) {
  //console.log('Menu Type 2 -> ', detail)

  const menuElem = menuBody[detail.id];

  for (let i = 0; i < menuElem.length; i++) {
    menuElem[i].start(detail, htmlDt, htmlFc);
  }

  detail.html = menuElem;

  detail.act = "show";
  menu.start(detail);
}

const menuBody = {
  tabMenu: [
    {
      text: "",
      svg: `customer`,
      class: `cont icon-blue`,

      start: function () {
        this.text = "Customer Credit"; //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"customercredit", "elem":"page", "id":"customercredit-page", "act":"show","leftnav": "leftnav-transaction-page" }
           ]}'`;
      },
    },

    { text: "line", start: function () {} }, //////////////line

    {
      text: "",
      svg: `sync`,
      class: `cont icon-blue`,

      start: function () {
        this.text = "Other Expense"; //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"otherexpense", "elem":"page", "id":"otherexpense-page", "act":"show","leftnav": "leftnav-transaction-page" }
           ]}'`;
      },
    },

    { text: "line", start: function () {} }, //////////////line

    {
      text: "",
      svg: `admin`,
      class: `cont icon-blue`,

      start: function () {
        this.text = "Employees Payment"; //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"employesspayment", "elem":"page", "id":"employesspayment-page", "act":"show","leftnav": "leftnav-transaction-page" }
           ]}'`;
      },
    },

    { text: "line", start: function () {} }, //////////////line

    {
      text: "",
      svg: `money`,
      class: `cont icon-blue`,

      start: function () {
        this.text = "Equity Deposit"; //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"equitydeposit", "elem":"page", "id":"equitydeposit-page", "act":"show","leftnav": "leftnav-transaction-page" }
           ]}'`;
      },
    },
  ],

  trMenu: [
    {
      text: "",
      svg: "eye",
      class: ``,
      dataDetail: ``,

      start: function (detail) {
        this.text = "View/Edit"; //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              { "dest":"accounts", "elem":"fullcont", "id":"accounts-fullcont", "act":"selectOne",  "entity":"accounts", "dbid": ${detail.dbid} }
           ]}'`;
      },
    },

    {
      text: "",
      svg: "print",
      class: ``, //same name as the title test

      dataDetail: "",

      start: function (detail) {
        this.text = "Print"; //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"accounts", "elem":"dt", "act":"trPrint", "entity":"accounts", "dbid":"${detail.dbid}" } 

        ]}'`;
      },
    },

    { text: "line", start: function () {} }, //////////////line

    {
      text: "",
      svg: "delete",
      class: ``,
      dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}
        ]}'`,

      start: function (detail) {
        this.text = "Delete"; //language.start('inProgress')
        this.dataDetail = `data-detail='{
                            "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"accounts", "elem":"fullcont", "act":"deleteEntity", "entity":"accounts", "dbid":["${detail.dbid}"] } 
           ]}'`;
      },
    },
  ],

  tableOptions: [
    {
      text: "",
      svg: "person",
      class: ``, //same name as the title test

      dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"},
                              {"dest":"accounts", "elem":"dialog", "id":"hellow", "act":"show"}
        ]}'`,

      start: function () {
        this.text = "Show Dialog"; //language.start('inProgress')
      },
    },

    { text: "line", start: function () {} }, //////////////line

    {
      text: "",
      svg: "delete",
      class: ``,
      dataDetail: ``,

      start: function (detail, htmlDt) {
        //console.log('startXXXXXXXXXXXXX')

        const ids = dtHandler.getTrChecked(htmlDt);

        //if exist one check
        if (ids.length > 0) {
          this.class = ``;
          this.text = `Delete All (${ids.length})`;
          this.dataDetail = `data-detail='{
                                    "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"accounts", "elem":"fullcont", "act":"deleteEntity", "entity":"accounts",  "dbid":[${ids}]} ]}'`;
        } else {
          this.class = `disabled`;
          this.text = `Delete All`;
          this.dataDetail = "";
        } /*if*/

        // console.log('startXXXXXXXXXXXXX', ids)
      } /**/,
    },
  ],

  fullcontOptions: [
    {
      text: "",
      svg: "edit",
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {
        this.text = `Edit`;
        this.dataDetail = `data-detail='{
                                   "click": [
                                      {"dest":"ripple" },
                                      {"dest":"menu", "act":"hide"},
                                      {"dest":"accounts", "elem":"fullcont",  "id":"accounts-fullcont", "act":"prepareEdit" }  ]}'`;
      } /**/,
    },

    {
      text: "",
      svg: "print",
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {
        //if exist one check
        this.class = ``;
        this.text = `Print`;
        this.dataDetail = `data-detail='{
                                     "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"accounts", "elem":"dt", "act":"trPrint"} ]}'`;
      } /**/,
    },

    { text: "line", start: function () {} }, //////////////line

    {
      text: "",
      svg: "delete",
      class: ``, //same name as the title test

      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {
        const dbid = htmlFc.fullcontHTML.getAttribute("data-dbid");

        //if exist one check
        this.class = ``;
        this.text = `Delete `;
        this.dataDetail = `data-detail='{
                                    "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"accounts", "elem":"fullcont", "act":"deleteEntity", "entity":"accounts",  "dbid":[${dbid}]} ]}'`;
      } /**/,
    },
  ],
}; /*menuBody*/